import BaseSkeleton from 'components/Generic/BaseSkeleton';

const FundDetailsTabSkeleton = () => (
  <div>
    {[...Array(6)].map((_item, index) => (
      <div key={index} className={index > 0 ? 'mt-3' : ''}>
        <BaseSkeleton height="64px" />
      </div>
    ))}
  </div>
);

export default FundDetailsTabSkeleton;
